import React, { useEffect, useState } from "react";
import Icon from "../../../../../../stories/core-components/IconsSelector";
import * as S from "./HomeCarousel.styles";

const HomeCarousel = ({ data }) => {
    let cardTime;
    const [activeCard, setActiveCard] = useState(0);

    useEffect(() => {
        clearTimeout(cardTime);
        cardTime = setInterval(() => {
            activeCard < data.length - 1 ? setActiveCard(activeCard + 1) : setActiveCard(0);
        }, 2000);
        return () => clearTimeout(cardTime);
    }, [activeCard]);


    return (
        <S.CarouselContainer>
            <S.CarouselCardContainer bgImage={data[activeCard]["bgImage"]}>
                <S.LeftSection>
                    <S.IconWrapper src={data[activeCard]["icon"]}></S.IconWrapper>
                </S.LeftSection>
                <S.RightSection>
                    <S.CarouselTitle>{data[activeCard]["title"]}</S.CarouselTitle>
                    <S.CarouselSubTitle>
                        {data[activeCard]["bodyText"]}
                    </S.CarouselSubTitle>
                    {data[activeCard]["knowMoreText"] && data[activeCard]["knowMoreUrl"] ?
                        <S.CarousellerCtaWrapper onClick={() => {
                            if (data[activeCard]["knowMoreUrl"]) { window.open(data[activeCard]["knowMoreUrl"]); }
                        }}>
                            <S.CarouselCta>{data[activeCard]["knowMoreText"]}</S.CarouselCta>
                            <Icon
                                name="ArrowRight"
                                styleProps={{ fill: '#fff' }}
                            />
                        </S.CarousellerCtaWrapper>
                        : <></>}
                </S.RightSection>
            </S.CarouselCardContainer>
        </S.CarouselContainer>
    );
}

export default HomeCarousel;
